var _a;
import { legatoCustomEventSchemas } from '@/events/constants/custom-event-schemas.constant';
import { getEventTracker } from 'hx-analytics';
export var useEvents = (_a = getEventTracker(legatoCustomEventSchemas), _a.useEvents), trackCustom = _a.trackCustom;
